export const DEAL_EVENT_TYPES = {
  COMPLETED: 'transaction.completed',
  VOIDED: 'transaction.voided',
  IS_UNDER_CONTRACT: 'transaction.is_under_contract',
  IS_ACTIVE_LISTING: 'transaction.is_active_listing',
  REVERTED_TO_ACTIVE_LISTING: 'transaction.reverted_to_active_listing',
  CLOSING_DATE_HAS_CHANGED: 'transaction.closing_date_has_changed',
  TASK_COMPLETED: 'task.completed',
  REVIEW_COMPLETED_SUCCESSFULLY: 'review.completed_successfully',
  REVIEW_COMPLETED_WITH_REMARKS: 'review.completed_with_remarks',
  EMAIL_TASK_SENT: 'email_task.sent',
  CLIENT_IS_INVITED: 'client.is_invited',
  CLIENT_IS_JOINED: 'client.is_joined',
  SIGN_DOCUMENT_SENT: 'sign_document.sent',
  SIGN_DOCUMENT_SIGNED_BY_ALL_USERS: 'sign_document.signed_by_all_users',
  SIGN_DOCUMENT_SIGNED_BY_ONE_USER: 'sign_document.signed_by_one_user',
  SIGN_DOCUMENT_EDITED: 'sign_document.edited',
  OFFER_PRICE_CREATED: 'offer_price.created',
  OFFER_PRICE_UPDATED: 'offer_price.updated',
};
